import React from 'react';
import { compose, graphql } from 'apollo';
import { withRouter } from 'utils/withRouter';

import withOrganizationPk from 'hoc/withOrganizationPk';
import withCurrentUser from 'hoc/withCurrentUser';
import withPermissions from 'hoc/withPermissions';
import withOrganizationModules from 'hoc/withOrganizationModules';

import billingInformationQuery from 'components/ActivateOrChangePlanButton/billingInformationQuery.gql';

import ApplicationDetails from './ApplicationDetails';
import candidateWithApplicationsQuery from '../CandidateWithApplications/candidateWithApplicationsQuery.gql';
import candidatesQuery from '../CandidatesList/candidatesQuery.gql';
import deleteApplicationMutation from './deleteApplicationMutation.gql';
import restoreApplicationMutation from './restoreApplicationMutation.gql';

function ApplicationDetailsContainer(props) {
  return <ApplicationDetails {...props} />;
}

export default compose(
  withOrganizationPk,
  withCurrentUser,
  withRouter,
  withPermissions,
  withOrganizationModules,
  graphql(deleteApplicationMutation, {
    props: ({ mutate }) => ({
      deleteApplication: (applicationPk, organizationPk) =>
        mutate({
          variables: { applicationPk, organizationPk },
          refetchQueries: [candidateWithApplicationsQuery, candidatesQuery],
        }),
    }),
  }),
  graphql(restoreApplicationMutation, {
    props: ({ mutate }) => ({
      restoreApplication: (applicationPk, organizationPk) =>
        mutate({
          variables: { applicationPk, organizationPk },
          refetchQueries: [candidateWithApplicationsQuery, candidatesQuery],
        }),
    }),
  }),
  graphql(billingInformationQuery, {
    options: ({ organizationPk }) => ({ variables: { organizationPk } }),
    props: ({ data: { viewer, loading } }) => ({
      billing: !loading && viewer ? viewer.organizations[0].billing : {},
    }),
  }),
)(ApplicationDetailsContainer);
